var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"page page--dashboard"},[_c('div',{staticClass:"container"},[_c('AdministrationTabs')],1),_c('div',{staticClass:"container"},[_c(_vm.dashboard,{tag:"component"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }